import type {PropsWithChildren} from 'react';

export interface DrawerProps extends PropsWithChildren {
  isOpen: boolean;
  className?: string;
  onClose: VoidFunction;
  overlay?: boolean;
  direction?: Direction;
  size?: DrawerSize;
  hasOverflowHidden?: boolean;
}

export enum DrawerSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
export enum Direction {
  LEFT = 'left',
  RIGHT = 'right',
}
